export default __webpack_public_path__ + "images/JC.16a5c72.png";